import { isAuthenticationRequiredSyncError } from '@/lib/sync/error-utils';
import { syncImages } from '@/lib/sync/images';
import type { UserId } from '@/schemas/ids';
import { enqueueSyncJob, registerSyncPlugin } from '../plugins.js';
import type { SyncPlugin } from '../plugins.js';

export const IMAGES_SYNC_PLUGIN_KEY = 'images';

const imagesPlugin: SyncPlugin<UserId> = {
  key: IMAGES_SYNC_PLUGIN_KEY,
  createJobKey(userId: UserId) {
    return `images:${String(userId)}`;
  },
  createMetadata(userId: UserId) {
    return {
      entity: 'images',
      scope: String(userId),
      source: 'images-sync-plugin',
    };
  },
  async run(userId: UserId) {
    await syncImages(userId);
  },
  shouldRetry(error) {
    return !isAuthenticationRequiredSyncError(error);
  },
};

const registerImagesPlugin = registerSyncPlugin as (
  plugin: SyncPlugin<UserId>,
) => SyncPlugin<UserId>;
registerImagesPlugin(imagesPlugin);

export function enqueueImagesSync(userId: UserId): void {
  const enqueue = enqueueSyncJob as (key: string, scope: UserId) => void;
  enqueue(IMAGES_SYNC_PLUGIN_KEY, userId);
}
